import { MainWrapper, InnerWrapper } from '../add-collaborator-flow/add-collaborator-flow.styled';
import EditCollaboratorPermissionLevelForm from './edit-collaborator-permission-level-form';

function EditCollaboratorFlow() {
  return (
    <MainWrapper>
      <InnerWrapper>
        <EditCollaboratorPermissionLevelForm />
      </InnerWrapper>
    </MainWrapper>
  );
}

export default EditCollaboratorFlow;
